document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-accordion-trigger]');
  if (!trigger) return;

  const item = trigger.closest('.accordion-item');
  const content = item?.querySelector('[data-accordion-content]');
  if (!item || !content) return;

  const expanded = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!expanded));
  content.hidden = expanded;
});

const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');
const siteHeader = document.querySelector('[data-site-header]');

const setMobileNavOpen = (open) => {
  if (!mobileNavToggle || !mobileNav || !siteHeader) return;

  mobileNav.hidden = !open;
  mobileNavToggle.setAttribute('aria-expanded', String(open));
  siteHeader.classList.toggle('mobile-nav-open', open);
  document.body.style.overflow = open ? 'hidden' : '';
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-nav-toggle]');
  if (toggle) {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    setMobileNavOpen(!expanded);
    return;
  }

  if (event.target.closest('[data-mobile-nav] a')) {
    setMobileNavOpen(false);
    return;
  }

  if (mobileNav && !mobileNav.hidden && siteHeader && !siteHeader.contains(event.target)) {
    setMobileNavOpen(false);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    setMobileNavOpen(false);
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 760) {
    setMobileNavOpen(false);
  }
});

// Bundle item logic
document.addEventListener('click', (event) => {
  const bundleItem = event.target.closest('.bundle-item');
  if (!bundleItem) return;

  const bundleContainer = bundleItem.closest('.product-bundle-options');
  if (!bundleContainer) return;

  bundleContainer.querySelectorAll('.bundle-item').forEach(i => i.classList.remove('is-active'));
  bundleItem.classList.add('is-active');

  const radio = bundleItem.querySelector('input[type="radio"]');
  if (radio) radio.checked = true;

  const qty = radio.value;
  const qtyInput = bundleContainer.closest('.product-panel').querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.value = qty;
    qtyInput.dispatchEvent(new Event('change'));
  }
});

const setActiveGalleryPanel = (galleryRoot, panelId) => {
  const panels = galleryRoot.querySelectorAll('[data-gallery-panel]');
  const thumbs = galleryRoot.querySelectorAll('[data-gallery-thumb]');

  panels.forEach((panel) => {
    const isActive = panel.getAttribute('data-gallery-panel') === panelId;
    panel.hidden = !isActive;
    panel.classList.toggle('is-active', isActive);
  });

  thumbs.forEach((thumb) => {
    const isActive = thumb.getAttribute('data-gallery-thumb') === panelId;
    thumb.setAttribute('aria-pressed', String(isActive));
    thumb.classList.toggle('is-active', isActive);
  });
};

document.querySelectorAll('[data-gallery-root]').forEach((galleryRoot) => {
  const initialThumb =
    galleryRoot.querySelector('[data-gallery-thumb][aria-pressed="true"]') ||
    galleryRoot.querySelector('[data-gallery-thumb]');

  if (initialThumb) {
    setActiveGalleryPanel(galleryRoot, initialThumb.getAttribute('data-gallery-thumb'));
  }

  galleryRoot.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb || !galleryRoot.contains(thumb)) return;

    setActiveGalleryPanel(galleryRoot, thumb.getAttribute('data-gallery-thumb'));
  });
});

const privacyChoiceRoots = document.querySelectorAll('[data-privacy-opt-out-root]');

const normalizeSaleOfDataConsent = (value) => {
  if (value === false || value === 'no') return 'opted_out';
  if (value === true || value === 'yes') return 'allowed';
  return 'unset';
};

const loadCustomerPrivacyApi = (callback) => {
  if (!window.Shopify?.loadFeatures) {
    callback(new Error('Shopify privacy controls unavailable'));
    return;
  }

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error) {
      callback(error);
      return;
    }

    if (!window.Shopify?.customerPrivacy) {
      callback(new Error('Shopify customer privacy API unavailable'));
      return;
    }

    callback(null, window.Shopify.customerPrivacy);
  });
};

privacyChoiceRoots.forEach((root) => {
  const statusNode = root.querySelector('[data-privacy-status]');
  const optOutButton = root.querySelector('[data-privacy-opt-out-button]');
  const optInButton = root.querySelector('[data-privacy-opt-in-button]');

  if (!statusNode || !optOutButton || !optInButton) return;

  const messages = {
    optedOut: root.dataset.optOutConfirmed || 'You have opted out of data sharing for this browser.',
    allowed: root.dataset.optInConfirmed || 'Data sharing is currently allowed for this browser.',
    unset: root.dataset.optOutDefault || 'No opt-out has been recorded for this browser yet.',
    help: root.dataset.optInDefault || 'You can allow or opt out of data sharing at any time from this page.',
    error: root.dataset.optOutError || 'We could not update your privacy preference automatically.',
  };

  const setBusy = (busy) => {
    root.setAttribute('aria-busy', String(busy));
    optOutButton.disabled = busy;
    optInButton.disabled = busy;
  };

  const setStatus = (state) => {
    const normalizedState = normalizeSaleOfDataConsent(state);
    statusNode.textContent = messages[normalizedState] || messages.help;
    optOutButton.setAttribute('aria-pressed', String(normalizedState === 'opted_out'));
    optInButton.setAttribute('aria-pressed', String(normalizedState === 'allowed'));
  };

  const refreshConsent = (customerPrivacy) => {
    try {
      const consent = customerPrivacy.currentVisitorConsent();
      setStatus(consent?.sale_of_data);
    } catch (error) {
      statusNode.textContent = messages.error;
    }
  };

  const updateConsent = (customerPrivacy, saleOfData) => {
    setBusy(true);
    customerPrivacy.setTrackingConsent({ sale_of_data: saleOfData }, () => {
      refreshConsent(customerPrivacy);
      setBusy(false);
    });
  };

  loadCustomerPrivacyApi((error, customerPrivacy) => {
    if (error || !customerPrivacy) {
      statusNode.textContent = messages.error;
      optOutButton.disabled = true;
      optInButton.disabled = true;
      return;
    }

    refreshConsent(customerPrivacy);

    optOutButton.addEventListener('click', () => updateConsent(customerPrivacy, false));
    optInButton.addEventListener('click', () => updateConsent(customerPrivacy, true));
  });
});

const suppressPopConvert = () => {
  document.getElementById('pop-convert-app')?.remove();
  document.getElementById('pop-convert-theme-integrations')?.remove();
};

suppressPopConvert();
window.addEventListener('load', suppressPopConvert);

const popConvertObserver = new MutationObserver(() => {
  suppressPopConvert();
});

popConvertObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

// Reveal on scroll logic
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach((el) => {
  revealObserver.observe(el);
});

// Mode switcher logic
document.querySelectorAll('[data-mode-switcher]').forEach((switcher) => {
  const btns = switcher.querySelectorAll('[data-mode-btn]');
  
  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const mode = btn.getAttribute('data-mode-btn');
      switcher.setAttribute('data-mode', mode);
      
      btns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });
});

// Header scroll polish
window.addEventListener('scroll', () => {
  if (window.scrollY > 50) {
    siteHeader?.classList.add('site-header--scrolled');
  } else {
    siteHeader?.classList.remove('site-header--scrolled');
  }
});

// Sticky Add to Cart
const stickyAtc = document.querySelector('[data-sticky-atc]');
const mainAtc = document.querySelector('[name="add"]');

if (stickyAtc && mainAtc) {
  const atcObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      stickyAtc.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  
  atcObserver.observe(mainAtc);
}
